import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';
import { actionUnderline } from 'core/components/theme/motion.styles';

// Reskin: quote-style text links (Amber's nav): 18px dark text, bark when selected, no icons, in a 72px header.
const styles = (theme) => ({
  root: {
    fontWeight: 300,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    padding: (smallPadding) => (smallPadding ? '' : '33px 0'),
    ...reskinStyles(theme, {
      fontSize: 18,
      fontWeight: 400,
      color: theme.colors.text_primary,
      minWidth: 0,
      minHeight: theme.sizes.headerHeight,
      padding: 0,
      '&:hover': { backgroundColor: 'transparent', color: theme.colorPalette.orange_50 }
    })
  },
  selected: {
    fontWeight: 600,
    color: theme.colors.header__label_primary,
    ...reskinStyles(theme, { fontWeight: 400, color: theme.colorPalette.orange_50 })
  },
  wrapper: {
    flexDirection: 'row',
    padding: (smallPadding) => (smallPadding ? '0 16px' : ''),
    ...reskinStyles(theme, { padding: theme.spacing(0, 4) })
  },
  smallIcon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(2),
    ...reskinStyles(theme, { display: 'none' })
  },
  largeIcon: {
    width: 30,
    height: 30,
    marginRight: theme.spacing(2),
    ...reskinStyles(theme, { display: 'none' })
  },
  label: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    ...actionUnderline(theme)
  }
});

export default makeStyles(styles);
